module.exports = __webpack_public_path__ + "static/img/service_logo.ec562dbf.png";